@if (!currentUser().featureDiscovery.shareCandidateOnboardingUsed) {
  <rt-infobox
    type="information"
    [imageTemplate]="infoboxImageTpl"
    [storageKey]="'share-candidate-onboarding'"
    [noBorder]="true"
    [messagePaddingSmall]="true"
    (dismissClick)="markFeatureDiscoveryAsUsed()"
    margin-bottom
  >
    <ng-template #infoboxImageTpl>
      <img src="assets/images/feature_guide.svg" alt="Feature guide" />
    </ng-template>
    <div font-weight-bold layout layout-vertical margin-left-small>
      {{
        'app.candidate.share_dialog.feature_discovery.tooltips.sharing_dropdown.title' | translate
      }}
      <a rtHelpArticle="accessToCandidate" class="link">{{
        'app.candidate.share_dialog.feature_discovery.tooltips.sharing_dropdown.learn_more'
          | translate
      }}</a>
    </div>
  </rt-infobox>
}
<rt-new-item-button
  #newItemButtonComponent
  icon="person-add"
  [heading]="'app.candidate.share_dialog.team_members.heading' | translate"
  [subheading]="'app.candidate.share_dialog.team_members.subheading' | translate"
  [disabled]="sharingDisabled()"
  [rtTooltip]="'app.candidate.admin_select.share_with_team.no_placements_tooltip' | translate"
  [rtTooltipEnabled]="sharingDisabled()"
  rtTooltipPosition="below"
  [rtTooltipHasTextAlignCenter]="true"
  [rtTooltipMaxWidth]="408"
  (click)="sharingDisabled() ? $event.stopPropagation() : newItemClick.emit()"
  data-cy="candidate-sharing-team-members-tab:add-team-members-button"
/>
@if (sharedWithUsers.length) {
  <div margin-top>
    <rt-heading variant="subheading" margin-bottom-small-x>
      {{ 'app.candidate.share_dialog.team_members.shared_with' | translate }}
    </rt-heading>
    <rt-candidate-shared-with-list
      [sharedWithUsers]="sharedWithUsers"
      [withActions]="true"
      [hasScroll]="false"
      (stopSharingClick)="handleStopSharing($event)"
      data-cy="candidate-sharing-team-members-tab:shared-with-list"
    />
  </div>
}
@if (!isWhoHasAccessHidden) {
  <div margin-top>
    <div class="toggler" (click)="toggleAccessExpanded()">
      <rt-heading variant="subheading" margin-right-small-xx>
        {{
          (sharedWithUsers.length
            ? 'app.candidate.share_dialog.team_members.who_else_has_access'
            : 'app.candidate.share_dialog.team_members.who_has_access'
          ) | translate
        }}
      </rt-heading>
      <rt-icon [name]="whoHasAccessExpanded ? 'keyboard-arrow-up' : 'keyboard-arrow-down'" />
    </div>
    @if (whoHasAccessExpanded) {
      <div margin-top-small-x>
        <rt-users-grouped-by-access-kind-list
          [usersGroupedByAccessKind]="usersAlreadyWithAccess()"
        />
      </div>
    }
  </div>
}
<rt-divider margin-top />
<rt-button
  variant="outline"
  (click)="copyLink()"
  [rtTooltip]="'app.candidate.share_dialog.team_members.copy_link_tooltip' | translate"
  [rtTooltipMaxWidth]="280"
  rtTooltipPosition="left"
  margin-top-medium
>
  <rt-icon name="content-copy" />
  {{ 'app.candidate.share_dialog.team_members.copy_link' | translate }}
</rt-button>
